import { render, staticRenderFns } from "./input-general-mail.vue?vue&type=template&id=6be95918&scoped=true"
import script from "./input-general-mail.vue?vue&type=script&lang=js"
export * from "./input-general-mail.vue?vue&type=script&lang=js"
import style0 from "./input-general-mail.vue?vue&type=style&index=0&id=6be95918&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be95918",
  null
  
)

export default component.exports